import { createTheme } from '../utils';
import * as MobileSummaryFlight from './components/MobileSummaryFlight.css';

export const defaultTheme = {
	MobileSummaryFlight
};

export default defaultTheme;

export const { useTheme } = createTheme<typeof defaultTheme>(defaultTheme);
